import { Atom, useAtomValue } from 'jotai';
import { FormattedGame } from '@/types/game';
import { NumberOption } from '@/types/generic';
import { useGetGamesByFilter, GamesFilterType } from './useGetGamesByFilter';

export const useGetFilteredOptions = (
  optionsAtom: Atom<Promise<NumberOption[]>>,
  filteredGamesDataAtom: Atom<Promise<FormattedGame[]>>,
  selectedGamesAtom: Atom<Promise<NumberOption[]>>,
  gamesFilterType: GamesFilterType,
) => {
  const options = useAtomValue(optionsAtom);
  const filteredTeamIds = useGetGamesByFilter(filteredGamesDataAtom, selectedGamesAtom, gamesFilterType);

  return options.filter(option => filteredTeamIds.includes(option.value));
};
